import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { Api } from '../../../api/gse/api';
import {
  getAllJobCards,
  GetAllJobCards$Params,
  updateJobCardStatus,
  UpdateJobCardStatus$Params,
  startJobServiceWorkLog,
  StartJobServiceWorkLog$Params,
  stopJobServiceWorkLog,
  StopJobServiceWorkLog$Params,
  finishJobServiceWorkLog,
  FinishJobServiceWorkLog$Params,
  createJobCardRefuelingLog,
  CreateJobCardRefuelingLog$Params,
  getJobCardById,
  GetJobCardById$Params,
} from '../../../api/gse/functions';
import { GetJobCardsResponse } from '../../../api/gse/models/get-job-cards-response';
import { ApiSuccess } from '../../../api/gse/models/api-success';
import { JobServiceWorkLogResponse } from '../../../api/gse/models/job-service-work-log-response';
import { RefuelingLogResponse } from '../../../api/gse/models/refueling-log-response';
import { JobCardDetailsResponse } from '../../../api/gse/models/job-card-details-response';

@Injectable({
  providedIn: 'root',
})
export class TechnicianService {
  constructor(private api: Api) {}

  getAllJobCards(params: GetAllJobCards$Params): Observable<GetJobCardsResponse> {
    return from(this.api.invoke(getAllJobCards, params));
  }

  updateJobCardStatus(params: UpdateJobCardStatus$Params): Observable<ApiSuccess> {
    return from(this.api.invoke(updateJobCardStatus, params));
  }

  startJobServiceWorkLog(params: StartJobServiceWorkLog$Params): Observable<JobServiceWorkLogResponse> {
    return from(this.api.invoke(startJobServiceWorkLog, params));
  }

  stopJobServiceWorkLog(params: StopJobServiceWorkLog$Params): Observable<JobServiceWorkLogResponse> {
    return from(this.api.invoke(stopJobServiceWorkLog, params));
  }

  finishJobServiceWorkLog(params: FinishJobServiceWorkLog$Params): Observable<JobServiceWorkLogResponse> {
    return from(this.api.invoke(finishJobServiceWorkLog, params));
  }

  createJobCardRefuelingLog(params: CreateJobCardRefuelingLog$Params): Observable<RefuelingLogResponse> {
    return from(this.api.invoke(createJobCardRefuelingLog, params));
  }

  getJobCardById(params: GetJobCardById$Params): Observable<JobCardDetailsResponse> {
    return from(this.api.invoke(getJobCardById, params));
  }
}
